/** * * Asynchronously loads the component for
Customer Dashboard
* */ import { lazyLoad } from "utils/loadable";
export const CustomerDashboard = lazyLoad(
  () => import("./index"),
  (module) => module.CustomerDashboard
);
